(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "68b11cc9e9f15e52450a486c";
              window.beaePageSetting.pageTitle = "Foot"; 
              window.beaePageSetting.pageType = "footer";

          let js_68SR7TBN = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-eki9mlnesection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-eki9mlne',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-eki9mlne');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-eki9mlne: ', ex)
      };
    

      try {
        let argid = 'beae-eki9mlnesection-developer',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-eki9mlne',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-eki9mlne');
        args.el = args.els[0];
        ((data
) => { function formFocusHandle() {
  const formFields = data.el.querySelectorAll('.beae-form-field');
  const inputWrapper = data.el.querySelector('.beae-form-container');

  if (formFields.length === 0 || inputWrapper == null) return;

  formFields.forEach((formField) => {
    const input = formField.querySelector('input, textarea');

    if (!input) return;

    input.addEventListener('focus', () => {
      inputWrapper.classList.add('beae-user-focus'); 
      formField.classList.add('active'); 
    });

    input.addEventListener('blur', () => {
      if (input.value == '') { 
        formField.classList.remove('active'); 
      }
    });
  });
}

formFocusHandle(); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-eki9mlne: ', ex)
      };
    

      try {
        let argid = 'beae-lmint366block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lmint366',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lmint366');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lmint366: ', ex)
      };
    

      try {
        let argid = 'beae-p2nuwnrcblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-p2nuwnrc',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-p2nuwnrc');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-p2nuwnrc: ', ex)
      };
    

      try {
        let argid = 'beae-kea9kakwsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-kea9kakw',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-kea9kakw');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-kea9kakw: ', ex)
      };
    

      try {
        let argid = 'beae-wjm49z1eblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wjm49z1e',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wjm49z1e');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wjm49z1e: ', ex)
      };
    

      try {
        let argid = 'beae-wjm49z1eblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wjm49z1e',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wjm49z1e');
        args.el = args.els[1];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wjm49z1e: ', ex)
      };
    

      try {
        let argid = 'beae-wjm49z1eblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wjm49z1e',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wjm49z1e');
        args.el = args.els[2];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wjm49z1e: ', ex)
      };
    

      try {
        let argid = 'beae-wjm49z1eblock-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wjm49z1e',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wjm49z1e');
        args.el = args.els[3];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wjm49z1e: ', ex)
      };
    

      try {
        let argid = 'beae-h19ngnj4block-form',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-h19ngnj4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-h19ngnj4');
        args.el = args.els[0];
        ((m) => { const h=window.location.href.indexOf("contact_posted=true")!==-1,p=m.el.querySelector("form");m.el.querySelector(".beae-btn-pr");const f=m.el.querySelectorAll("input","select","button","textarea","checkbox","radio"),b=m.el.querySelector(".btn-lightbox-form > button");!h&&m.mode.value!=="builder"&&(m.el.querySelector(".beae-form-success-message").style="display: none"),h&&m.afterSubmitting=="redirect"&&m.redirect&&(m.el.querySelector(".beae-form-success-message").style="display: block",window.location.href=m.redirect);const k=[];p&&p.addEventListener("submit",g=>{g.preventDefault();for(let v=0;v<f.length;v++)k.push({fieldKey:f[v].name,fieldType:f[v].type,fieldValue:f[v].value})}),b&&(b.onclick=()=>{const g=document.createElement("div");g.innerHTML=p.outerHTML||"",window.BeaePopupLibrary.createPopup(g,{layout:"center",layoutMobile:"bottom",width:"500px",id:m.id})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-h19ngnj4: ', ex)
      };
    

      try {
        let argid = 'beae-urbwnml7section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-urbwnml7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-urbwnml7');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-urbwnml7: ', ex)
      };
    

      try {
        let argid = 'beae-bseq4ca5section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-bseq4ca5',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-bseq4ca5');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-bseq4ca5: ', ex)
      };
    

      try {
        let argid = 'beae-5hu4zj76block-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-5hu4zj76',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-5hu4zj76');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-5hu4zj76: ', ex)
      };
    

      try {
        let argid = 'beae-ukdk1vhablock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ukdk1vha',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ukdk1vha');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ukdk1vha: ', ex)
      };
    

      try {
        let argid = 'beae-5hu4zj76block-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-5hu4zj76',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-5hu4zj76');
        args.el = args.els[1];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-5hu4zj76: ', ex)
      };
    

      try {
        let argid = 'beae-ukdk1vhablock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ukdk1vha',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ukdk1vha');
        args.el = args.els[1];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ukdk1vha: ', ex)
      };
    

      try {
        let argid = 'beae-5hu4zj76block-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-5hu4zj76',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-5hu4zj76');
        args.el = args.els[2];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-5hu4zj76: ', ex)
      };
    

      try {
        let argid = 'beae-ukdk1vhablock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ukdk1vha',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ukdk1vha');
        args.el = args.els[2];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ukdk1vha: ', ex)
      };
    

      try {
        let argid = 'beae-5hu4zj76block-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-5hu4zj76',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-5hu4zj76');
        args.el = args.els[3];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-5hu4zj76: ', ex)
      };
    

      try {
        let argid = 'beae-ukdk1vhablock-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ukdk1vha',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ukdk1vha');
        args.el = args.els[3];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ukdk1vha: ', ex)
      };
    

      try {
        let argid = 'beae-4nt6k8bksection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4nt6k8bk',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4nt6k8bk');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4nt6k8bk: ', ex)
      };
    

      try {
        let argid = 'beae-bf4fs0yxblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-bf4fs0yx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-bf4fs0yx');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const O=M.el.closest(".beae-slider-items");O&&!O.hasAttribute("data-svg")&&(O==null||O.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),O.setAttribute("data-svg","true"))}let H=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=H.querySelector(".beae-img-ratio-control"),L=H.querySelector(".beae-img-comp-container"),T=H.querySelector(".beae-img-comp-container--second");if(V&&T){let O=function(A){let D=0,Z;q(),z?H.onmouseover=function(U){W(U)}:A.onmousedown=function(U){W(U)},H.onmouseup=function(){j()},A.ontouchstart=function(U){W(U)},H.ontouchend=function(){j()};function q(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function W(U){check=!1,U.preventDefault(),U.clientX?U.clientX:U.touches[0].clientX,parseInt(A.style.left),D=1,H.onmousemove=function(K){R(K)},H.ontouchmove=function(K){R(K)}}function j(){D=0,check=!0}function R(U){if(D==0)return!1;Z=G(U),Z<0&&(Z=0),Z>100&&(Z=100),F(Z)}function G(U){const K=H.getBoundingClientRect(),oe=(U.changedTouches?U.changedTouches[0].clientX:U.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(oe*100/I)))}function F(U){A.style.left=U+"%",T.style.clipPath=`polygon(${U}% 0%, ${U}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${U}% 0%, ${U}% 100%)`}};V&&T&&O(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),O(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",H=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),H.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-bf4fs0yx: ', ex)
      };
    

      try {
        let argid = 'beae-mq2md3opblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-mq2md3op',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-mq2md3op');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-mq2md3op: ', ex)
      };
    

      try {
        let argid = 'beae-f53fddumlinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-f53fddum',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-f53fddum');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),k=f.el.querySelector(".beae-linkslist");b===null||k===null||b.addEventListener("click",g=>{window.matchMedia("(max-width: 767px)").matches&&k.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-f53fddum: ', ex)
      };
    

      try {
        let argid = 'beae-edrev7s8linkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-edrev7s8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-edrev7s8');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),k=f.el.querySelector(".beae-linkslist");b===null||k===null||b.addEventListener("click",g=>{window.matchMedia("(max-width: 767px)").matches&&k.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-edrev7s8: ', ex)
      };
    

      try {
        let argid = 'beae-i4a0e1kllinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-i4a0e1kl',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-i4a0e1kl');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),k=f.el.querySelector(".beae-linkslist");b===null||k===null||b.addEventListener("click",g=>{window.matchMedia("(max-width: 767px)").matches&&k.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-i4a0e1kl: ', ex)
      };
    

      try {
        let argid = 'beae-tmqb3r1yblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-tmqb3r1y',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-tmqb3r1y');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-tmqb3r1y: ', ex)
      };
    

      try {
        let argid = 'beae-3v4oszoklc-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3v4oszok',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3v4oszok');
        args.el = args.els[0];
        ((m) => { let h=m.checkLive;function p(_){return{input:_.querySelector('input[name="locale_code"], input[name="country_code"]'),button:_.querySelector("button.beae-current-value"),panel:_.querySelector(".beae-language-results"),search:_.querySelector('input[name="language_filter"]'),resetButton:_.querySelector(".beae-reset-button")}}function f(_,M){const V=m.el.querySelector("form.beae-localization");M.input.value=_.currentTarget.dataset.value,V&&V.submit()}function b(_){_.button.focus(),_.panel.classList.toggle("hidden-dropdown"),_.button.setAttribute("aria-expanded",(_.button.getAttribute("aria-expanded")==="false").toString());const M=_.button.getBoundingClientRect();window.innerHeight-M.bottom<_.panel.offsetHeight?(_.panel.style.top="auto",_.panel.style.bottom="100%"):(_.panel.style.top="100%",_.panel.style.bottom="auto")}function k(_){return _.normalize("NFD").replace(/\p{Diacritic}/gu,"").toLowerCase()}function g(_,M){const V=k(M.search.value),L=_.querySelectorAll(".beae-languages li");L.length,M.resetButton.classList.toggle("hidden",!V),L.forEach(T=>{k(T.querySelector(".beae-language-name").textContent).indexOf(V)>-1?T.classList.remove("beae-hidden"):T.classList.add("beae-hidden")})}function v(_){_.code.toUpperCase()==="ENTER"&&_.preventDefault()}function S(_,M,V){_.stopPropagation(),V.search.value="",g(M,V)}function B(_,M,V){(!M.contains(_.target)||!M.contains(_.relatedTarget))&&(C(M,V),V.button.setAttribute("aria-expanded",(V.button.getAttribute("aria-expanded")==="false").toString()))}function C(_,M){M.panel.classList.add("hidden-dropdown"),M.search&&(M.search.value="",g(_,M))}function $(_){const M=p(_);h&&_.addEventListener("focusout",V=>B(V,_,M)),M.button.addEventListener("click",()=>b(M)),_.querySelectorAll(".beae-language-name").forEach(V=>V.addEventListener("click",L=>f(L,M))),M.search&&(M.search.addEventListener("keyup",()=>g(_,M)),M.search.addEventListener("keydown",v)),M.resetButton&&(M.resetButton.addEventListener("click",V=>S(V,_,M)),M.resetButton.addEventListener("mousedown",V=>V.preventDefault()))}m.el.querySelectorAll(".beae-localization").forEach($) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3v4oszok: ', ex)
      };
    

      try {
        let argid = 'beae-8d31xfkqblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-8d31xfkq',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-8d31xfkq');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const O=M.el.closest(".beae-slider-items");O&&!O.hasAttribute("data-svg")&&(O==null||O.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),O.setAttribute("data-svg","true"))}let H=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=H.querySelector(".beae-img-ratio-control"),L=H.querySelector(".beae-img-comp-container"),T=H.querySelector(".beae-img-comp-container--second");if(V&&T){let O=function(A){let D=0,Z;q(),z?H.onmouseover=function(U){W(U)}:A.onmousedown=function(U){W(U)},H.onmouseup=function(){j()},A.ontouchstart=function(U){W(U)},H.ontouchend=function(){j()};function q(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function W(U){check=!1,U.preventDefault(),U.clientX?U.clientX:U.touches[0].clientX,parseInt(A.style.left),D=1,H.onmousemove=function(K){R(K)},H.ontouchmove=function(K){R(K)}}function j(){D=0,check=!0}function R(U){if(D==0)return!1;Z=G(U),Z<0&&(Z=0),Z>100&&(Z=100),F(Z)}function G(U){const K=H.getBoundingClientRect(),oe=(U.changedTouches?U.changedTouches[0].clientX:U.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(oe*100/I)))}function F(U){A.style.left=U+"%",T.style.clipPath=`polygon(${U}% 0%, ${U}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${U}% 0%, ${U}% 100%)`}};V&&T&&O(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),O(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",H=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),H.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-8d31xfkq: ', ex)
      };
    }; if (window.BEAEBASE) {js_68SR7TBN()} else {window.BEAEPAGEJS.push(js_68SR7TBN)} })(); 